var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.023,
    height: 43.022,
    viewBox: "0 0 43.023 43.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a9229dc89fa3aa066b8db7fab507f84a{fill:currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H43.023V43.022H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a9229dc89fa3aa066b8db7fab507f84a",
    d: "M30.682,4l3.263,6.525a.451.451,0,0,1-.394.645H30a1.752,1.752,0,0,1-1.6-.986L25.3,4H21.719l3.263,6.525a.451.451,0,0,1-.394.645H21.038a1.752,1.752,0,0,1-1.6-.986L16.341,4H12.756l3.263,6.525a.451.451,0,0,1-.394.645H12.075a1.8,1.8,0,0,1-1.613-.986L7.378,4H5.585A3.6,3.6,0,0,0,2,7.585V29.1a3.6,3.6,0,0,0,3.585,3.585H34.267A3.6,3.6,0,0,0,37.853,29.1V5.793A1.8,1.8,0,0,0,36.06,4Z",
    transform: "translate(1.585 3.17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.d7aa335348f20437f834d1ca0c664f31.svg";
export { ForwardRef as ReactComponent };